export default "__VITE_ASSET__0c1e6bbc__"